<template>
<div>
  <van-nav-bar title="请假详情" left-text="返回" right-text="" @click-left="onClickLeft"/>
</div>
</template>

<script>
export default {
  name: "detail",
  methods:{
    onClickLeft: function () {
      let path = '/attenceflow/leave/list';
      this.$router.push({
        path: path,
        query: {}
      });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/leave/detail.vue